import React, { useState, useEffect } from 'react';
import '../../css/InstagramFeed.css';
import '../../css/Fondo.css';

const InstagramFeed = () => {
    const [profileHeight, setProfileHeight] = useState(0);
    const profile = "https://www.instagram.com/bingo.bahia/embed";

    const offsetSinBoton = -66; // No muestra el boton de instagram para ver el perfil completo
    const offsetSinBotonMobile = -50;
    //const offsetConBoton = 5; // Muestra el boton de instagram para ver el perfil completo. Sirve para cualquier width

    useEffect(() => {
        window.addEventListener('message', (event) => {
            if (event.origin.includes("instagram.com")) {
                try {
                    const data = JSON.parse(event.data);
                    if (data.type === "MEASURE" && data.details?.height) {
                        if (window.innerWidth <= 534) {
                            setProfileHeight(data.details.height + offsetSinBotonMobile); // Mobile width
                        } else {
                            setProfileHeight(data.details.height + offsetSinBoton); 
                        }
                    }
                } catch (error) {
                    console.error("Error obteniendo informacion desde Instagram: ", error);
                }
            }
        });
        
        return () => {
            window.removeEventListener('message', () => {});
        };
    }, [offsetSinBoton, offsetSinBotonMobile])


    return (
        <div
            id="noticiasfeed"
            className='fondo-1'
            style={{
                color: "#FFD700",
                textAlign: "center",
                minHeight: "50vh",
            }}
        >
            <iframe
                src={profile}
                scrolling="no"
                loading='lazy'
                allow="encrypted-media"
                className='instagram-profile my-4'
                style={{ height: `${profileHeight}px`, boxShadow: "0px 4px 20px rgba(0, 0, 0, 0.4)" }}
                title={`Perfil de Instagram`}
            />
        </div>
    );
};

export default InstagramFeed;
